module.exports = __webpack_public_path__ + "static/img/K_pikes.6682d76.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cards/K_pikes.svg
// module id = WFfz
// module chunks = 1